// extracted by mini-css-extract-plugin
module.exports = {"svg":"CircularProgress_svg__3sOd_","rotate":"CircularProgress_rotate__G-Uyo","circle":"CircularProgress_circle__1JpHZ","dash":"CircularProgress_dash__2hCl-"};